module.exports = __webpack_public_path__ + "static/img/banner2.6cc0a047.png";